var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.39453 15.0312H22.4792",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4792 12.2779V20.7253C22.4438 24.0924 21.5222 24.9431 18.0133 24.9431H6.86045C3.29247 24.9431 2.39453 24.057 2.39453 20.5363V12.2779C2.39453 9.08799 3.13885 8.06013 5.93889 7.89472C6.22243 7.88291 6.52965 7.87109 6.86045 7.87109H18.0133C21.5813 7.87109 22.4792 8.75718 22.4792 12.2779Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0241 8.08455V16.3429C26.0241 19.5328 25.2798 20.5607 22.4798 20.7261V12.2787C22.4798 8.75798 21.5818 7.87189 18.0139 7.87189H6.86102C6.53021 7.87189 6.223 7.8837 5.93945 7.89552C5.9749 4.52838 6.89646 3.67773 10.4054 3.67773H21.5582C25.1262 3.67773 26.0241 4.56382 26.0241 8.08455Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23438 21.1738H8.26644",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7949 21.1738H14.8591",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardsWhite);
export default __webpack_public_path__ + "static/media/cards-white.02322f5d557301f38ba190ddfc3663f6.svg";
export { ForwardRef as ReactComponent };